import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { TESTIMONIALS } from "../lib/content";

export default function Testimonials() {
  const [i, setI] = useState(0);
  const next = () => setI((p) => (p + 1) % TESTIMONIALS.length);
  const prev = () => setI((p) => (p - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const current = TESTIMONIALS[i];

  return (
    <section data-testid="testimonials" className="relative py-24 md:py-32 lg:py-40 bg-white">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 text-[#B8965A]">
          <span className="block w-8 h-px bg-[#C9A86A]" />
          <span className="text-[11px] uppercase tracking-[0.3em]">Client Words</span>
        </div>
        <h2 className="font-display-bold text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#0A0A0A] mt-6 max-w-3xl">
          What Sydney's most discerning <span className="font-serif-italic font-light text-[#B8965A]">homes & hotels</span> say.
        </h2>

        <div className="mt-14 md:mt-20 relative min-h-[280px]">
          <Quote className="absolute -top-4 -left-2 w-12 h-12 text-[#C9A86A]/35" strokeWidth={1} />
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -14 }}
              transition={{ duration: 0.5 }}
              className="relative"
            >
              <p className="font-serif-italic text-2xl md:text-3xl lg:text-4xl text-[#0A0A0A]/85 leading-snug">
                “{current.quote}”
              </p>
              <footer className="mt-8 flex items-center gap-4">
                <span className="block w-10 h-px bg-[#C9A86A]" />
                <div>
                  <div className="text-[#0A0A0A] text-sm" data-testid="testimonial-name">{current.name}</div>
                  <div className="text-[#525252] text-xs uppercase tracking-[0.2em] mt-1">{current.role}</div>
                </div>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="mt-14 flex items-center justify-between border-t border-black/10 pt-6">
          <div className="text-[#525252] text-sm">
            <span className="text-[#0A0A0A]">{String(i + 1).padStart(2, "0")}</span>
            <span className="mx-3 text-black/30">/</span>
            {String(TESTIMONIALS.length).padStart(2, "0")}
          </div>
          <div className="flex gap-3">
            <button data-testid="testimonial-prev" onClick={prev} className="w-12 h-12 inline-flex items-center justify-center border border-black/15 text-[#0A0A0A] hover:border-[#B8965A] hover:text-[#B8965A] transition-colors" aria-label="Previous testimonial">
              <ChevronLeft className="w-4 h-4" />
            </button>
            <button data-testid="testimonial-next" onClick={next} className="w-12 h-12 inline-flex items-center justify-center border border-black/15 text-[#0A0A0A] hover:border-[#B8965A] hover:text-[#B8965A] transition-colors" aria-label="Next testimonial">
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
